<template>
  <v-app>
    <MobileAppBar v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" />
    <AppBar
      v-if="
        $vuetify.breakpoint.md ||
          $vuetify.breakpoint.lg ||
          $vuetify.breakpoint.xl
      "
    />

    <router-view />

    <SiteFooter />
  </v-app>
</template>

<script>
export default {
  components: {
    AppBar: () => import("@/components/core/AppBar"),
    MobileAppBar: () => import("@/components/core/MobileAppBar"),
    SiteFooter: () => import("@/components/core/SiteFooter"),
  },
  props: {
    source: String,
  },
  data: () => ({
    drawer: false,
    links: [
      { name: "Home", link: "/", icon: "mdi-home" },
      { name: "About", link: "/about", icon: "mdi-information-outline" },
    ],
    toolLinks: [
      { name: "Plate Calculator", link: "/platecalc", icon: "mdi-calculator" },
      { name: "BMR Calculator", link: "/bmrcalc", icon: "mdi-scale" },
      { name: "Macro Calculator", link: "/macrocalc", icon: "mdi-food" },
    ],
    servicesLinks: [
      {
        name: "Calculators",
        link: "/services/customcalc",
        icon: "fa-calculator",
      },
      {
        name: "Forms",
        link: "/services/customcalc",
        icon: "fa-keyboard",
      },
      {
        name: "Dashboards",
        link: "/services/customcalc",
        icon: "fa-tachometer-alt",
      },
    ],
  }),
  methods: {
    goHome() {
      this.$router.push("/");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || "Robin Lange";
      },
    },
  },
};
</script>

<style></style>
